import { getSuggestions, type MailSuggestionContext } from '../utils/getSuggestions';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import type { ComposeViewState } from 'owa-mail-compose-store';

export const shouldOmitPopover = (
    context: MailSuggestionContext | undefined,
    mailboxInfo: MailboxInfo,
    composeViewState?: ComposeViewState
): boolean => {
    return (
        !getSuggestions(context, composeViewState, mailboxInfo) &&
        !isGlobalFeatureEnabled('copilot-dab-mail-3s-sua')
    );
};
